import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import TagCardSkeleton from '@/app/components/listing/skeleton-loaders/TagCardSkeleton.vue'

const numberOfCardsToRender = 12
const numberOfCardsToHideDesktop = 6

export default /*@__PURE__*/_defineComponent({
  __name: 'TagsBlockSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListingBlockLayout, {
    title: "Book Categories",
    class: "tags-block-skeleton"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(numberOfCardsToRender, (i) => {
        return _createVNode(TagCardSkeleton, {
          key: i,
          class: _normalizeClass(i > numberOfCardsToHideDesktop && 'skeleton-tag--hide-desktop')
        }, null, 8, ["class"])
      }), 64))
    ]),
    _: 1
  }))
}
}

})